import { render, staticRenderFns } from "./PublisherBannerList.vue?vue&type=template&id=2c07385d&scoped=true"
import script from "./PublisherBannerList.vue?vue&type=script&lang=js"
export * from "./PublisherBannerList.vue?vue&type=script&lang=js"
import style0 from "./PublisherBannerList.vue?vue&type=style&index=0&id=2c07385d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07385d",
  null
  
)

export default component.exports